const Buy: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.38 12.79L12.5 15.67L12.5 2.5C12.5 1.95 12.05 1.5 11.5 1.5C10.95 1.5 10.5 1.95 10.5 2.5L10.5 15.67L7.62 12.79C7.23 12.4 6.6 12.4 6.21 12.79C5.82 13.18 5.82 13.81 6.21 14.2L10.8 18.79C11.19 19.18 11.82 19.18 12.21 18.79L16.8 14.2C17.19 13.81 17.19 13.18 16.8 12.79C16.41 12.41 15.77 12.4 15.38 12.79ZM16.5 20.5L6.5 20.5C5.95 20.5 5.5 20.95 5.5 21.5C5.5 22.05 5.95 22.5 6.5 22.5L16.5 22.5C17.05 22.5 17.5 22.05 17.5 21.5C17.5 20.95 17.05 20.5 16.5 20.5Z" fill="currentColor" />
  </svg>
);

export default Buy;
